/**
 * The current 3rd-person orbit camera yaw, published once per frame by world3d. Lets static world props
 * (e.g. Kapon's directional tents / skull totems) pick their facing sprite by the same yaw the character
 * billboards use, without threading the camera through every scene-build signature.
 */
export const cameraView = { yaw: 0 };
